import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { createVNode, h } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import router from '@/router';
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time *= 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (`${time}`.length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();
  const diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  }
  if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`;
  }
  if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`;
  }
  if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  }
  return `${d.getMonth() + 1}月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split('&');
  searchArr.forEach(v => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

// 获取状态码
export function getStatusCode(val) {
  let code = '';
  if (val) {
    switch (val) {
      case '已废弃':
        code = '3';
        break;
      case '未响应':
        code = '0';
        break;
      case '待报价':
        code = '1';
        break;
      case '已完成':
        code = '2';
        break;
    }
  }
  return code;
}

// 通过状态码获取val
export function getStatus(val) {
  let code = '';
  if (val) {
    switch (val) {
      case '3':
        code = '已废弃';
        break;
      case '0':
        code = '未响应';
        break;
      case '1':
        code = '待报价';
        break;
      case '2':
        code = '已完成';
        break;
    }
  }
  return code;
}
const goToLogin = (type, msg) => {
  if (type && msg && type === 'success') {
    _message.success(msg);
  } else if (type && msg && type === 'error') {
    _message.error(msg);
  }
  router.push('/login');
};

// 登录提示弹窗
const appointment = () => {
  // 预约
  let hasLogin = false; // 登录状态
  if (localStorage.getItem('vuex')) {
    // 获取登录状态
    const users = JSON.parse(localStorage.getItem('vuex') || '');
    hasLogin = users.user.hasLogin;
  }
  if (!hasLogin) {
    _Modal.confirm({
      title: '您还没有登录，请点击前往登录',
      icon: createVNode(ExclamationCircleOutlined),
      okText: '确定',
      cancelText: '取消',
      centered: true,
      onOk() {
        router.push('/login');
      },
      onCancel() {}
    });
  } else {
    appointmentSuccess();
  }
};

// 预约
const appointmentSuccess = () => {
  _Modal.success({
    title: '预约成功',
    content: h('div', {
      class: 'appointment'
    }, [h('p', '已经联系您的专属商务，稍后将由商务与您进行对接。')])
  });
};

/**
 * @description 时间戳转化为年 月 日 时 分 秒
 * @method formatTime(timestap,format)
 * @param {number} [timestap = new Date().getTime()] 时间戳,默认使用当前时间戳, new Date().getTime(); 获取当前时间戳（毫秒）
 * @param {string} [format='YYYY-mm-dd HH:MM:SS'] 时间格式,不填时默认使用'YYYY-mm-dd HH:MM:SS'格式,更改只需替换中间连接符号就行'YYYY年mm月dd日 HH时MM分SS秒'
 * @example
 *  var sjc = 1472048779952; //js一般获取的时间戳是13位，PHP一般是10位
    formatTime(sjc, 'YYYY-mm-dd HH:MM:SS')
 */

const formatTimes = (timestap, format = 'YYYY-MM-DD hh:mm:ss') => {
  let ret;
  let date;
  let renum;
  // 处理时间戳，将10位的时间戳处理为13位
  if (timestap.toString().length === 10) {
    date = new Date(parseInt(timestap.toString()) * 1000);
  } else {
    date = new Date(parseInt(timestap.toString()));
  }
  const option = {
    Y: date.getFullYear().toString(),
    // 年
    M: (date.getMonth() + 1).toString(),
    // 月
    D: date.getDate().toString(),
    // 日
    h: date.getHours().toString(),
    // 时
    m: date.getMinutes().toString(),
    // 分
    s: date.getSeconds().toString() // 秒
  };
  for (let key in option) {
    ret = new RegExp(`(${key}+)`).exec(format);
    if (ret) {
      const val = option[key] || '';
      // 根据复数前面是否补零,如“mm”补零，单“m”前面不补零
      renum = ret[1].length === 1 ? val : val.padStart(ret[1].length, '0');
      format = format.replace(ret[1], renum); // 替换
    }
  }
  return format;
};
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
};
export { goToLogin, appointment, formatTimes, debounce };